import { useState, useEffect } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:8080";

const SERVICES = [
  "Office & Workplace Cleaning",
  "Retail & Showroom Cleaning",
  "Industrial & Warehouse Cleaning",
  "Medical & Healthcare Cleaning",
  "Education & School Cleaning",
  "Common Area & Facility Cleaning",
  "Move-In / Move-Out Cleaning",
  "Floor Polishing & Hard Floor Care",
  "Builders & Post-Construction Cleaning",
  "Deep & Intensive Cleaning",
  "Carpet Steam Cleaning",
  "Internal & External Window Cleaning",
  "High-Touch Surface Sanitisation",
  "Exterior & Walkway Cleaning",
  "High Ceiling & Wall Cleaning",
  "Other",
];

const EMPTY = { name: "", email: "", phone: "", service: "", customService: "", message: "" };

const QuoteModal = ({ onClose }) => {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  // Close on Escape
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        service: form.service === "Other" ? form.customService.trim() : form.service,
        message: form.message.trim(),
      };
      const res = await fetch(`${API}/?url=quote/send`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.success) {
        setSent(true);
      } else {
        setError(data.error || "Something went wrong. Please try again.");
      }
    } catch {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(0,0,0,0.55)", display: "flex",
        alignItems: "center", justifyContent: "center", padding: "16px",
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        style={{
          background: "#fff", borderRadius: 14, width: "100%", maxWidth: 520,
          maxHeight: "90vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          position: "relative",
        }}
      >
        {/* Header */}
        <div style={{ background: "#1a1a1a", borderRadius: "14px 14px 0 0", padding: "20px 24px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <h4 style={{ margin: 0, color: "#fff", fontWeight: 700, fontSize: 18 }}>Get a Free Quote</h4>
              <p style={{ margin: "4px 0 0", color: "#aaa", fontSize: 13 }}>We'll get back to you within 24 hours</p>
            </div>
            <button
              onClick={onClose}
              style={{
                background: "rgba(255,255,255,0.1)", border: "none", borderRadius: 8,
                color: "#fff", cursor: "pointer", width: 32, height: 32,
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0,
              }}
            >
              &times;
            </button>
          </div>
        </div>

        <div style={{ padding: "24px" }}>
          {sent ? (
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <div style={{
                width: 64, height: 64, borderRadius: "50%", background: "#d1fae5",
                display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px",
              }}>
                <i className="fa fa-check" style={{ color: "#059669", fontSize: 28 }} />
              </div>
              <h5 style={{ fontWeight: 700, color: "#1a1a1a", marginBottom: 8 }}>Quote Request Sent!</h5>
              <p style={{ color: "#666", fontSize: 14, marginBottom: 24 }}>
                Thank you! We've received your request and will be in touch within 24 hours.
              </p>
              <button
                onClick={onClose}
                style={{
                  background: "#1a1a1a", color: "#fff", border: "none",
                  borderRadius: 8, padding: "10px 28px", cursor: "pointer", fontWeight: 600,
                }}
              >
                Close
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && (
                <div style={{
                  background: "#fff5f5", border: "1px solid #fca5a5", color: "#b91c1c",
                  borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 13,
                }}>
                  {error}
                </div>
              )}

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px", marginBottom: 14 }}>
                <div style={{ gridColumn: "1 / -1" }}>
                  <label style={labelStyle}>Your Name *</label>
                  <input
                    name="name" type="text" required value={form.name}
                    onChange={handleChange} placeholder="John Smith"
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Email Address *</label>
                  <input
                    name="email" type="email" required value={form.email}
                    onChange={handleChange} placeholder="john@example.com"
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Phone Number *</label>
                  <input
                    name="phone" type="tel" required value={form.phone}
                    onChange={handleChange} placeholder="+64 22 000 0000"
                    style={inputStyle}
                  />
                </div>
                <div style={{ gridColumn: "1 / -1" }}>
                  <label style={labelStyle}>Service Required *</label>
                  <select
                    name="service" required value={form.service}
                    onChange={handleChange} style={inputStyle}
                  >
                    <option value="">— Select a service —</option>
                    {SERVICES.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>
                {form.service === "Other" && (
                  <div style={{ gridColumn: "1 / -1" }}>
                    <label style={labelStyle}>Please describe the service *</label>
                    <input
                      name="customService" type="text" required value={form.customService}
                      onChange={handleChange} placeholder="Describe the cleaning service you need"
                      style={inputStyle}
                    />
                  </div>
                )}
                <div style={{ gridColumn: "1 / -1" }}>
                  <label style={labelStyle}>Additional Details <span style={{ color: "#9ca3af", fontWeight: 400 }}>(optional)</span></label>
                  <textarea
                    name="message" rows={3} value={form.message}
                    onChange={handleChange}
                    placeholder="Size of premises, frequency, any specific requirements…"
                    style={{ ...inputStyle, resize: "vertical" }}
                  />
                </div>
              </div>

              <button
                type="submit" disabled={loading}
                style={{
                  width: "100%", background: "#1a1a1a", color: "#fff",
                  border: "none", borderRadius: 8, padding: "12px", fontSize: 15,
                  fontWeight: 600, cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.7 : 1, transition: "opacity .2s",
                }}
              >
                {loading ? "Sending…" : "Send Quote Request"}
              </button>

              <p style={{ textAlign: "center", color: "#9ca3af", fontSize: 12, marginTop: 12, marginBottom: 0 }}>
                Or call us directly:{" "}
                <a href="tel:+64220866040" style={{ color: "#1a1a1a", fontWeight: 600 }}>+64 22 086 6040</a>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

const labelStyle = {
  display: "block", fontSize: 13, fontWeight: 600,
  color: "#374151", marginBottom: 6,
};

const inputStyle = {
  width: "100%", border: "1px solid #d1d5db", borderRadius: 8,
  padding: "9px 12px", fontSize: 14, color: "#111", outline: "none",
  boxSizing: "border-box", background: "#fafafa",
};

export default QuoteModal;
